<!--
 * @Descripttion: 柱状图配置
 * @Author: zenghua.wang
 * @Date: 2021-05-31 11:16:01
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-13 09:35:23
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      :apis="main.apiTableList"
    >
      <template v-slot:extend>
        <echart-field
          :data="data"
          :showType="showType"
        />
        <echart-filter :data="data" />
      </template>
    </api-interface>

    <el-collapse-item title="柱状图">
      <el-form-item label="竖向展示">
        <el-switch
          v-model="data.option.showCategory"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="柱体最大宽度">
        <el-slider v-model="data.option.barWidth" />
      </el-form-item>

      <el-form-item label="柱体圆角">
        <el-slider
          v-model="data.option.borderRadius"
          max="100"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- echart公共 -->
    <echart-common :data="data" />
  </el-collapse>
</template>
<script>
import configBase from '@/dragComponents/config/common/base.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import echartField from '@/dragComponents/config/common/field.vue'
import echartFilter from '@/dragComponents/config/common/filter.vue'

import echartCommon from './common.vue'

import {
  predefineColors,
  component,
  theme
} from '@/dragComponents/model/default.js'

export default {
  name: 'config-echart-bar',
  components: {
    configBase,
    echartCommon,
    echartField,
    echartFilter,
    apiInterface
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component,
      showType: [
        {
          label: '图表名称',
          value: 'name',
          tips: '备注：'
        },
        {
          label: '图表数值',
          value: 'value',
          tips: '1、图表名称仅能选择一个字段；图表数值可选择一个或多个字段，注意：若设置了标记组，图表数值只能选择一个字段；'
        },
        {
          label: '标记组',
          value: 'group',
          tips: '2、标记组是以图表名称分组，进行第二维度展示多柱体(标记组字段)。例如：图表名称(区域)、图表数值(学校数目)、标记组(学校)，标记组就是该区域内所含学校；'
        }
      ]
    }
  },
  methods: {}
}
</script>
